<template>
  <div id="chapter">
    <ul class="chapter">
      <li v-for="(item,index) in sectionList" :key="index">
        <div class="box">
          <h3>{{item.video.name}}</h3>
          <p>
            <span v-for="(user, index) in item.video.speakerList" :key="index">{{ user.name }}</span>
            <i>时长：{{ videoDuration(item.video.duration) }}</i>
          </p>
        </div>
        <CourseListType :data_videoInfo="courseInfo" :item="item" :toPayFor_n="toPayFor_n"/>
      </li>
    </ul>
  </div>
</template>
<script>
  import CourseListType from "@c/course/CourseListType";
  import { videoDuration } from "@/utils/methods.js";
  export default {
    name: "orderform",
    components: {
      CourseListType
    },
    computed: {
      // 根据 秒 转成 分钟：秒
      videoDuration() {
        return (second) => {
          return videoDuration(second);
        };
      },
    },
    props:['courseInfo','sectionList','toPayFor_n'],
  }
</script>
<style lang="scss" scoped>
  #chapter{
    margin-top: 10px;
  }
  .chapter {
    background: #FBFBFB;
    padding: 0 25px;
    border-radius: 6px;

    li{
      padding: 15px 0;
      border-bottom: 1px solid #F0F0F0;
      display: flex;
      align-items: center;
      &:last-of-type{
        border-bottom: none;
      }

      .box{
        flex: 1;
        margin-right: 15px;
        h3{
          font-size: 16px;
        }
        p {
          font-size: 12px;
          margin-top: 8px;

          span{
            margin-right: 20px;
          }

          i {
            color: #646464;
          }
        }
      }
      .amount {
        display: flex;
        align-items: baseline;

        dd {
          font-size: 16px;
          color: #FF6624;
          display: flex;
          align-items: baseline;

          &:last-of-type {
            margin-left: 10px;
          }

          b {
            font-weight: bold;
            font-size: 22px;
          }
        }
      }
    }
  }
</style>
